module.exports = __webpack_public_path__ + "static/datenschutz-7a5b9cf4ac253af9994a1c1abbc5b359.pdf";